import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// custom
import { store } from './common/state/store';
import './index.css';
import App from './app/App';
import { Auth0Provider } from '@auth0/auth0-react';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Auth0Provider
    domain="dev-p2wsfw6h.us.auth0.com"
    clientId="7W8NDPvXuZ4W2Bz7wLM1EUtyZgdaFsvd"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://api.powerministry.link",
      scope: "openid profile email"
    }}
  >    
    <Provider store={store}>
      <ToastContainer/>
      <App />
    </Provider>     
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
